// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"36": "06b9276a","365": "a0aba57c","58": "59e811d8","633": "b4392c70","646": "fba78169","819": "285e5077",}[chunkId] + ".css"
}